import { render, staticRenderFns } from "./flag_used_ai.vue?vue&type=template&id=2a35d324&"
import script from "./flag_used_ai.vue?vue&type=script&lang=js&"
export * from "./flag_used_ai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports